module.exports = __webpack_public_path__ + "img/close-icon.b3451c3b.svg";